export default __webpack_public_path__ + "static/media/regulatory--no-left-turn--g2.3a06039e.png";